"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconHomeCharging = function IconHomeCharging(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m46 15.586-11-11-11 11V19h2v-2.586l9-9 9 9V33h2zM41 17h-5v7h5zm-1 1v5h-3v-5zm-30.562.974 4.13 4.14-.01.01a3.91 3.91 0 0 1 0 5.532 3.91 3.91 0 0 1-5.375.153l-.16-.152-5.96-5.97 1.415-1.414 5.96 5.97-.822.821.822-.82a1.91 1.91 0 0 0 2.706-.002 1.91 1.91 0 0 0 .114-2.58l-.114-.124.718-.72-.71.708-4.129-4.139a4.64 4.64 0 0 1-.618-5.8 5 5 0 0 1 .424-6.59l2.525-2.523 1.495 1.495 1.865-1.857 1.412 1.417-1.863 1.855 1.341 1.34 1.83-1.822 1.412 1.417-1.828 1.82 1.406 1.406-2.524 2.524a5 5 0 0 1-5.95.84 2.64 2.64 0 0 0 .345 2.91l.142.154-.716.716zm5.157-6.43-4.242-4.242-1.11 1.11a3 3 0 0 0-.02 4.223l.144.137a3 3 0 0 0 4.119-.117zm9.378 14.287-8.063-7.685-1.38 1.448 8.515 8.115 9.218 1.468.125.027a1.1 1.1 0 0 1 .789 1.262l-.86 4.631-.029.119a1.1 1.1 0 0 1-1.056.784H27.9a5.002 5.002 0 0 0-9.8 0H7v2h11.1a5.002 5.002 0 0 0 9.8 0h3.33l.186-.005a3.1 3.1 0 0 0 2.867-2.534l.86-4.628.032-.207a3.1 3.1 0 0 0-.548-2.151l-.127-.167a3.1 3.1 0 0 0-1.925-1.106zM23 35a3 3 0 1 1 0 6 3 3 0 0 1 0-6m-1.5 3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m2 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M15 36v-1h-4v1z",
    clipRule: "evenodd"
  })));
};

export { IconHomeCharging, IconHomeCharging as default };
